module.exports = __webpack_public_path__ + "img/265-3.4366f0c1.jpg";